import "./PartnersSection.css"
import { useTranslation } from "react-i18next"
const partners = [
  { name: "Avery Dennison", src: "/images/logos/Avery-Dennison.png" },
  { name: "TrafFix Devices Inc.", src: "/images/logos/traffix-logo.jpg" },
  { name: "Ver-Mac", src: "/images/logos/ver-mac-logo-hi-signs-trafficsupply-trafficrentals.jpg" },
  { name: "Delta (Force Technology)", src: "/images/logos/DeltaLogo-big.jpg" },
  { name: "Rayolite", src: "/images/logos/Rayolite_274pix.jpg" },
  { name: "SMA", src: "/images/logos/sma-logo.png" },
  { name: "Midsign", src: "/images/logos/midsign-logo.png" },
]
export function PartnersSection() {
  const { t } = useTranslation()
  return (
    <section id="brands" className="partners">
      <div className="container">
        <p className="partners__label">{t("Trusted brands we supply and represent")}</p>
      </div>
      <div className="partners__marquee">
        <div className="partners__track">
          {Array.from({ length: 4 }, (_, groupIndex) => (
            <div
              key={groupIndex}
              className="partners__group"
              aria-hidden={groupIndex > 0 ? "true" : undefined}
            >
              {partners.map((partner) => (
                <div key={partner.name} className="partners__item" title={partner.name}>
                  <img
                    src={partner.src}
                    alt={groupIndex === 0 ? partner.name : ""}
                    className="partners__logo"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}